import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
// 
class ContactUS extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />


                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                Contact Us
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Contact US</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <section className="myContactPage contact-section fix section-padding">
                    <div className="container">
                        <div className="contact-wrapper-2">
                            <div className="row mt_40" data-aos="fade-up" data-aos-delay={500}>
                                <div className="col-md-7 col-sm-12">
                                    <div className="project-in-mind">
                                        <div className="title_div">
                                            <h2 className="section-heading">
                                                Get In Touch
                                                With Us!
                                            </h2>
                                        </div>
                                        <div>
                                            <div className="contact_content">
                                                <figure>
                                                    <img
                                                        src="https://immensetek.com/wp-content/uploads/2022/07/location_3222642_termoffice20mappage1position3page1position3related_id3222642originsearch-1.png"
                                                        height={51}
                                                        width={51}
                                                    />
                                                </figure>
                                                <div className="contact_data">
                                                    <h4>India ITME Society,</h4>
                                                    <p>
                                                        1210/1211/1212 Dalamal Tower, ‘A’ Wing, 12th Floor, Plot
                                                        No.211, Nariman Point, Mumbai – 400 021, INDIA
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="contact_content">
                                                <figure>
                                                    <img
                                                        src="https://immensetek.com/wp-content/uploads/2022/07/phone-1.png"
                                                        height={51}
                                                        width={51}
                                                    />
                                                </figure>
                                                <div className="contact_data">
                                                    <h4>Contact Us</h4>
                                                    <p className="contact_p">
                                                        <i className="fa fa-phone" /> +91-22-4972 4603
                                                    </p>
                                                    <p className="contact_p">
                                                        <i className="fa fa-mobile" /> +91-9920 8226 45 (For
                                                        Registration Queries)
                                                    </p>
                                                    {/* <p class="contact_p"><i class="fab fa-whatsapp"></i> +91 8010 823 774 (For Administration Queries)</p> */}
                                                    <p className="contact_p">
                                                        <i className="fa fa-envelope" />{" "}
                                                        business.desk@india-itme.com
                                                    </p>
                                                    <p className="contact_p">
                                                        <i className="fa fa-skype" /> indiaitme2012
                                                    </p>
                                                    <p className="contact_p text-left">
                                                        <i className="fa fa-globe" />{" "}
                                                        https://tradedesk.india-itme.com/
                                                    </p>
                                                </div>
                                            </div>
                                            {/* <p class="visit_class">Visit India ITME 2022 Virtual Booth</p> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5 col-sm-12 order-md-2">
                                    {/* <div class="booking_query_main_div">
                      <div class="booking_query_person_grid_view">
                          <div>
                              <p class="title">Stall Booking & Operatiions Queries</p>
                          </div>
                          <div>
                              <h6>Mr. Nitin Pachpande</h6>
                              <p>+91 8010823774</p>
                              <p>+91 2249724603 (India Office Number)</p>
                              <p>projects@india-itme.com</p>
                              <hr/>
                              <h6>Mr. Tushar A. Jayawant</h6>
                              <p>+91 9820507570</p>
                              <p>operations@india-itme.com</p>

                          </div>
                      </div>
                      <hr/>
                      <div class="booking_query_person_grid_view">
                          <div>
                              <p class="title">Accounts Queries</p>
                          </div>
                          <div>
                              <h6>Mr. Ammey Kuware</h6>
                              <p>+91 8591951767</p>
                              <p>accounts@india-itme.com</p>
                              <hr/>
                              <h6>Mr. Nilesh Arondekar</h6>
                              <p>+91 8169627107</p>
                              <p>accounts03@india-itme.com</p>
                          </div>
                      </div>
                      <hr/>
                      <div class="booking_query_person_grid_view">
                          <div>
                              <p class="title">For Adminstration & Registration Queries</p>
                          </div>
                          <div>
                              <h6>Mr. Bhupendra Thakur</h6>
                              <p>+91 7021089987</p>
                              <p>admin@india-itme.com</p>
                          </div>
                      </div>
                  </div> */}
                                    <div className="booking_query_main_div">
                                        <div className="workingTime_grid_view">
                                            <div className="workingDays">
                                                <h6>Working days</h6>
                                                <p>Monday - Friday</p>
                                            </div>
                                            <div className="workingDays">
                                                <h6>Working Hrs</h6>
                                                <p>10:00 am to 06:00 pm, IST (GMT +05:30)</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                <div className="map-section">
                    <div className="map-items">
                        <div className="googpemap">
                            <iframe
                                src="https://www.google.com/maps/embed/v1/place?q=India+ITME+Society&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>


                <Footer />
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, {})(ContactUS));